import { PayrollContextlessPoliciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const usePayrollContextlessPolicies = () => {
  const { data, loading } = useQuery(PayrollContextlessPoliciesDocument)
  const payrollPolicies = data?.payroll?._policies
  const bookkeepersManagementPolicies = data?.bookkeepersManagement?._policies
  const reportPolicies = data?.reports?._policies

  return {
    loading,
    canImportSupplements: !!payrollPolicies?.supplementsImportSupplements.can,
    canDownloadPayrollData: !!payrollPolicies?.downloadPayrollData.can,
    canUpsellSeeActivationPromo: !!payrollPolicies?.upsellSeeActivationPromo.can,
    canSeePayrollIncidencesSettings:
      !!bookkeepersManagementPolicies?.seePayrollIncidencesSettings.can,
    canManagePayrollIncidences: !!payrollPolicies?.managePayrollIncidences.can,
    canSeeCompanyPayrollResults: !!payrollPolicies?.resultsSeeCompanyPayrollResults.can,
    canSeePayrollIssues: !!payrollPolicies?.seePayrollIssues.can,
    canSeeCompanySepaGenerator: !!payrollPolicies?.seeCompanySepaGenerator.can,
    canUseReports: !!reportPolicies?.useReports.can,
  }
}
